import http from "@/settings/apiSettings"

class RoluriDataService 
{
    get(): Promise<any> {
      return http.clientAuth.get("/AUTH_Roluri/GetRoluri");
    }
    save(data: any): Promise<any> {
      return http.clientAuth.post("/AUTH_Roluri/AddRol", data);
    }
    update(data: any): Promise<any> {
      return http.clientAuth.put("/AUTH_Roluri/UpdateRol", data);
    }
    delete(id: number): Promise<any> {
      return http.clientAuth.delete(`/AUTH_Roluri/DeleteRole/${id}`)
    }
}

export default new RoluriDataService();